import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AppShell } from '../../components/AppShell';
import { Button } from '../../components/Button';
import { ReferralRow } from '../../components/ReferralRow';
import { Spinner } from '../../components/Spinner';
import { apiGet, ClientApiError } from '../../api/client';
import type { Referral } from '../../../shared/types';

export function ReferralListScreen() {
  const [referrals, setReferrals] = useState<Referral[] | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    apiGet<{ referrals: Referral[] }>('/api/referrals')
      .then((data) => setReferrals(data.referrals))
      .catch((caught) =>
        setError(caught instanceof ClientApiError ? caught.message : 'Could not load your referrals.'),
      );
  }, []);

  return (
    <AppShell title="My Referrals">
      <Link to="/referrals/new" style={{ textDecoration: 'none' }}>
        <Button full>Add Customer</Button>
      </Link>

      <div style={{ marginTop: '1rem' }}>
        {error && (
          <div className="error-banner" role="alert">
            {error}
          </div>
        )}
        {!referrals && !error && <Spinner label="Loading your referrals" />}
        {referrals?.length === 0 && (
          <p className="muted">
            No referrals yet. Tap Add Customer when you find damage on a job.
          </p>
        )}
        {referrals?.map((referral) => (
          <ReferralRow
            key={referral.id}
            referral={referral}
            to={`/referrals/${referral.id}`}
            plumberView
          />
        ))}
      </div>
    </AppShell>
  );
}
